export default function reducer(state = {
  sucursalesFM: undefined,
  lastFetched: undefined
}, action) {
  switch (action.type) {
    case "LOAD_SUCURSALES_FM": {
      state = { ...state, ...action.payload }
      break
    }
    default: {

    }
  }
  return state
}